// this will scroll the input element to the top of the page when you type in, so you can see more of the results
// that would most likely be under it for a typeahead
angular.module('aprima-core-ui').directive('apScrollOnInput', [function () {
        'use strict';
        
        return {
            restrict: 'A',
            link: function($scope, element, attr){
                var topOffset = 0;
                
                function scroll(){
                    var offset = element.parent().offset();
                    window.scrollTo(offset.left, offset.top - topOffset);
                }
                
                if(attr.scrollTopOffset){
                    topOffset = parseInt(attr.scrollTopOffset);
                }
                
                element.on('input', scroll);
                
                $scope.$on('$destroy', function(){
                   element.off('input', scroll); 
                });
            }  
        };
    }]);
